export default __webpack_public_path__ + "static/media/resume.0df7996a.pdf";